import React from 'react'

const Index = ({onClick,children,className}) => {
  return (
    <button className={`mx-auto rounded-lg bg-[#181E4B] px-4 py-2 text-white w-fit text-center text-lg ${className}`} onClick={onClick}>{children}</button>
  )
}

export default Index